import { render, staticRenderFns } from "./RemoteFile.vue?vue&type=template&id=22557b4d&scoped=true"
import script from "./RemoteFile.vue?vue&type=script&lang=js"
export * from "./RemoteFile.vue?vue&type=script&lang=js"
import style0 from "./RemoteFile.vue?vue&type=style&index=0&id=22557b4d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22557b4d",
  null
  
)

export default component.exports